// The URL is the source of truth, including a direct link opened in a new tab.
const BOARD_KEYS = ['project', 'repo', 'tier', 'orden', 'orden_pending', 'orden_claimed', 'orden_review', 'orden_done', 'orden_blocked', 'pendiente', 'hallazgos', 'view', 'state', 'kind', 'page'];

export function boardParams(source) {
    const result = new URLSearchParams();
    for (const key of BOARD_KEYS) {
        const value = source.get(key);
        if (value) result.set(key, value);
    }
    return result;
}

export function boardLink(path, source, extra = {}) {
    const params = boardParams(source);
    for (const [key, value] of Object.entries(extra)) params.set(key, value);
    const query = params.toString();
    return `${path}${query ? `?${query}` : ''}`;
}
